export const getProgramsCategory = state => state.programs;
